import { headerBlocks, } from "./receipt-template.js";
import { printedDay } from "./statement.js";
export const uniformGradeFor = (input) => {
    const blocks = headerBlocks({
        company: input.company,
        template: input.template,
    });
    blocks.push({ kind: 'rule' }, {
        kind: 'text',
        text: input.orderLabel.toUpperCase(),
        align: 'center',
        big: true,
        bold: true,
    }, { kind: 'rule' }, { kind: 'pair', label: 'Cliente', value: input.customerName }, { kind: 'pair', label: 'Cidade', value: input.customerCity ?? '—' }, { kind: 'pair', label: 'Designer', value: input.designerName ?? '—' }, { kind: 'pair', label: 'Responsável', value: input.responsibleName ?? '—' }, {
        kind: 'pair',
        label: 'Entrega',
        value: input.dispatchDate ?? 'a definir',
    }, { kind: 'pair', label: 'Evento', value: input.event }, { kind: 'pair', label: 'Tecido', value: input.fabric }, { kind: 'pair', label: 'Logística', value: input.logistics }, {
        kind: 'pair',
        label: 'Quantidade de peças',
        value: String(input.pieces),
        bold: true,
    }, { kind: 'rule' }, {
        kind: 'text',
        bold: true,
        text: 'Prezado cliente, confira abaixo os tamanhos de cada modelo. A entrega será ' +
            'feita conforme esta grade; alterações posteriores não serão de ' +
            `responsabilidade de ${input.company.name}.`,
    }, { kind: 'feed', lines: 1 });
    if (input.tables.length === 0 && input.personalization.length === 0) {
        blocks.push({
            kind: 'text',
            text: 'A grade deste pedido ainda não foi preenchida.',
            align: 'center',
        });
    }
    for (const table of input.tables) {
        blocks.push({ kind: 'text', text: table.title, bold: true }, {
            kind: 'table',
            columns: [
                { label: 'Peça' },
                ...table.sizes.map((size) => ({
                    label: size,
                    align: 'center',
                })),
                { label: 'Total', align: 'right' },
            ],
            rows: table.rows.map((row) => [
                row.piece,
                ...row.quantities,
                row.total,
            ]),
            footer: ['Total', ...table.sizes.map(() => ''), table.total],
        });
    }
    if (input.personalization.length > 0) {
        const total = input.personalization.reduce((sum, row) => sum + Number(row.quantity), 0);
        blocks.push({ kind: 'text', text: 'Personalizados', bold: true }, {
            kind: 'table',
            columns: [
                { label: 'Nome' },
                { label: 'Peça' },
                { label: 'Cor' },
                { label: 'Nº', align: 'center' },
                { label: 'Qtde', align: 'right' },
                { label: 'Tam.', align: 'center' },
            ],
            rows: input.personalization.map((row) => [
                row.name,
                row.piece,
                row.color.trim() === '' ? '—' : row.color,
                row.number,
                row.quantity,
                row.size,
            ]),
            footer: ['Total', '', '', '', String(total), ''],
        });
    }
    if (input.notes !== null && input.notes.trim() !== '') {
        blocks.push({ kind: 'rule' }, { kind: 'text', text: 'Observações', bold: true }, { kind: 'text', text: input.notes.trim() });
    }
    blocks.push({ kind: 'rule' }, {
        kind: 'text',
        text: `Impresso em ${printedDay(input.printedAt)}`,
        align: 'right',
    });
    return {
        kind: 'grade',
        title: `Grade — ${input.orderLabel}`,
        blocks,
    };
};
//# sourceMappingURL=uniform-grade.js.map